import $ from 'jquery';
import 'bootstrap';

class ResetPassword {

    modal = null;
    backdrop = null;
    constructor() {
        this.modal = document.getElementById('resetPasswordModal');
        

        this.setupSubmit();

        let dismissBtns = this.modal.getElementsByClassName('btn-close-modal');
        for (let db of dismissBtns) {
            db.addEventListener('click', (evt) => {
                let emailField = document.getElementById("resetPasswordEmail");
                emailField.value = "";
                this.hide();
            });
        }

    }

   

    setupSubmit() {
        
        let submitBtn = document.getElementById('resetPasswordSubmit');

        submitBtn.addEventListener('click', (evt) => {

            let emailField = document.getElementById("resetPasswordEmail");

            let email = emailField.value;
            if (!email || email.length < 3) {
                evt.preventDefault();
                let resetPasswordEmailValidationMessage = document.getElementById('resetPasswordEmailValidationMessage');
                resetPasswordEmailValidationMessage.innerHTML = "Email is required"
            }

        });
    }

    show() {
        this.backdrop = document.createElement('div');
        this.backdrop.classList.add("modal-backdrop", "fade", "show");
        this.backdrop.style.position = 'absolute';
        this.backdrop.style.width = '100%';
        this.backdrop.style.height = '100%';
        this.backdrop.style.x = '100%';
        this.backdrop.style.height = '100%';

        document.body.append(this.backdrop);

        this.modal.style.display = 'block';
        this.modal.classList.add('show');
    }
    hide() {
        if (this.backdrop)
            this.backdrop.remove();
        this.modal.style.display = 'none';
        this.modal.classList.remove('show');

    }
}
export default ResetPassword;
